import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import InputGroup from 'react-bootstrap/InputGroup';

import { fetchRequest } from '../../fetchRequest';
import { TOAST_WARN } from './shopUtils';

export function EbarimtModal({ show, onClose, onConfirm, onFocusedChange }) {

    const [ebarimtType, setEbarimtType] = useState('CITIZEN');
    const [ebarimtRegister, setEbarimtRegister] = useState('');
    const [ebarimtOrganization, setEbarimtOrganization] = useState(null);

    const loadOrganizationInfo = (register = null) => {
        setEbarimtOrganization(null);
        fetchRequest("system/ebarimt-organization", 'POST', { register })
            .then(res => {
                if (res?.success) {
                    setEbarimtOrganization(res?.info);
                } else {
                    toast.warning(res?.message || 'Байгууллагын мэдээлэл олдсонгүй', TOAST_WARN);
                }
            }).catch(() => {
                toast.warning('Хүсэлт илгээхэд алдаа гарлаа', TOAST_WARN);
            });
    };

    const handleClose = () => {
        setEbarimtType('CITIZEN');
        setEbarimtRegister('');
        setEbarimtOrganization(null);
        onClose();
    };

    return (
        <Modal
            show={show}
            size='xl'
            dialogClassName="modal-90h"
            backdrop="static"
            onHide={handleClose}>
            <Modal.Body className={'p-0'} style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: 50 }}>
                <Row style={{ marginTop: 20, marginBottom: 10 }}>
                    <Col className='text-center'>
                        <Button type={'button'} className='btn-close-shop' variant="secondary" onClick={handleClose}>
                            <Image alt='close' className="icon-close" src={`/assets/images/ic_close.png`} />
                        </Button>
                    </Col>
                </Row>
                <Row style={{ flex: 1, flexDirection: 'column', justifyContent: 'center' }}>
                    <Row>
                        <Col md={1} lg={2} />
                        <Col md={10} lg={8}>
                            <Row>
                                <h2>И-баримтаа авах төрлөө сонгоно уу.</h2>
                            </Row>
                        </Col>
                    </Row>

                    <Row style={{ marginTop: 40 }}>
                        <Col md={2} lg={2} />
                        <Col md={8} lg={8}>
                            <Row>
                                <Button type={'button'}
                                    className={ebarimtType === 'CITIZEN' ? 'btn-close-shop btn-green' : 'btn-close-shop'}
                                    variant="secondary"
                                    onClick={() => {
                                        setEbarimtOrganization(null);
                                        setEbarimtRegister('');
                                        setEbarimtType('CITIZEN');
                                    }}
                                    style={{ color: 'black', fontSize: 25, fontFamily: 'PinnacleBold' }}>
                                    Хувь хүн
                                </Button>
                            </Row>
                            <Row style={{ marginTop: 20 }}>
                                <Button type={'button'}
                                    className={ebarimtType === 'ORGANIZATION' ? 'btn-close-shop btn-green' : 'btn-close-shop'}
                                    variant="secondary"
                                    onClick={() => {
                                        setEbarimtOrganization(null);
                                        setEbarimtRegister('');
                                        setEbarimtType('ORGANIZATION');
                                    }}
                                    style={{ color: 'black', fontSize: 25, fontFamily: 'PinnacleBold' }}>
                                    Байгууллага
                                </Button>
                            </Row>
                            {ebarimtType === 'ORGANIZATION' && <>
                                <Row style={{ marginTop: 20 }}>
                                    <InputGroup style={{ zIndex: '0 !important' }}>
                                        <Form.Control
                                            aria-label="Байгууллагын регистр"
                                            placeholder='Байгууллагын регистрийн дугаар'
                                            size='lg'
                                            style={{ borderRight: 'none' }}
                                            value={ebarimtRegister}
                                            onChange={(e) => {
                                                setEbarimtOrganization(null);
                                                setEbarimtRegister(e.target.value);
                                            }}
                                            onFocus={() => onFocusedChange(true)}
                                            onKeyUp={(e) => {
                                                if (e.key === 'Enter') {
                                                    loadOrganizationInfo(ebarimtRegister);
                                                }
                                            }}
                                            onBlur={() => onFocusedChange(false)}
                                        />
                                        <Button
                                            type={'button'}
                                            variant="outline-secondary"
                                            className='btn-search'
                                            onClick={() => {
                                                if (ebarimtRegister && ebarimtRegister.trim().length > 0) {
                                                    loadOrganizationInfo(ebarimtRegister);
                                                }
                                            }}
                                        >
                                            <Image alt='search' className="icon-dashboard" src={`/assets/images/ic_search.png`} />
                                        </Button>
                                    </InputGroup>
                                </Row>
                                {ebarimtOrganization && (
                                    <Row style={{ marginTop: 10 }}>
                                        <span>{ebarimtOrganization?.name}</span>
                                    </Row>
                                )}
                            </>}
                        </Col>
                    </Row>

                    <Row style={{ marginTop: 30 }}>
                        <Col md={1} lg={2} />
                        <Col md={10} lg={8}>
                            <Button
                                style={{ float: 'right' }}
                                className="btn-main"
                                disabled={ebarimtType !== 'CITIZEN' ? !ebarimtOrganization : false}
                                onClick={() => {
                                    onConfirm({ type: ebarimtType, register: ebarimtRegister });
                                    handleClose();
                                }}>
                                Үргэлжлүүлэх
                            </Button>
                        </Col>
                    </Row>
                </Row>
            </Modal.Body>
        </Modal>
    );
}
